<template>
  <div class="breadcrumb">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item, index) in currentData" :key="index">{{item}}</el-breadcrumb-item>
    </el-breadcrumb>
    <slot></slot>
  </div>
</template>

<script type="text/ecmascript-6">
import routeData from './data.js'
export default {
  mounted() {
    this.getData()
  },
  data () {
    return {
      currentData: []
    }
  },
  methods: {
    getData() {
      routeData.forEach(element => {
        if (element.key === this.$route.path) {
          this.currentData = element.value
        }
      })
    }
  },
  components: {

  },
  watch: {
    $route: 'getData'
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .breadcrumb
    margin-top 15px
    padding 10px
    background #fff
</style>
